import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Schedule } from '../../data/entities';

interface ScheduleState {
  schedulesByUser: { [userId: number]: Schedule[] };
}

const initialState: ScheduleState = {
  schedulesByUser: {}
};

const scheduleSlice = createSlice({
  name: 'schedules',
  initialState,
  reducers: {
    setSchedules: (state, action: PayloadAction<{ userId: number; schedules: Schedule[] }>) => {
      state.schedulesByUser[action.payload.userId] = action.payload.schedules;
    },
    invalidateSchedules: (state, action: PayloadAction<number | undefined>) => {
      if (action.payload) {
        // Clear specific user's schedules
        delete state.schedulesByUser[action.payload];
      } else {
        // Clear all schedules
        state.schedulesByUser = {};
      }
    },
  },
});

export const { setSchedules, invalidateSchedules } = scheduleSlice.actions;
export default scheduleSlice.reducer;